import BaseRepository from "@/services/resources/repository";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema);
    }

    record(id) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .include('person-citations')
                    .include('citation-specialisations')
                    .find(id)
            )
        );
    }

    withSpecialisationsAndPeople() {
        return this.transformer.many(
            this.try(
                this.baseQuery()
                    .include('citation-specialisations.specialisations')
                    .include('person-citations.people')
                    .get()
            )
        );
    }
}

export default Repository;
